import { Link } from "react-router-dom";
import ContactSection from "../../components/ContactSection";
import Icon from "../../components/icons";
import MotionMedia from "../../components/MotionMedia";
import ProofSection from "../../components/ProofSection";
import PageHero from "../../components/PageHero";
import Reveal from "../../components/Reveal";
import SiteLayout from "../../components/SiteLayout";

const principles = [
  { number: "01", title: "Understand before prescribing", copy: "We start with the business and the people using the product. Technology follows the problem—not the other way around." },
  { number: "02", title: "Make progress visible", copy: "Working software, clear decisions, and regular checkpoints keep the project grounded and everyone aligned." },
  { number: "03", title: "Build for life after launch", copy: "Maintainability, ownership, and room to evolve are product requirements from the beginning." },
];

const AboutComponent = () => (
  <SiteLayout>
    <PageHero
      eyebrow="About CMJ"
      title={<>A software partner that keeps the <span>human part</span> in view.</>}
      description="CMJ Software helps organizations turn meaningful ideas into useful, resilient products through a direct and collaborative process."
    >
      <div className="hero-actions">
        <Link className="button" to="/#contact">Start a conversation <Icon name="arrow" /></Link>
      </div>
    </PageHero>

    <section className="light-section about-statement">
      <div className="site-container statement-grid">
        <Reveal><p className="statement-label">Why we exist</p></Reveal>
        <Reveal delay={90}>
          <h2>Good software should make the next decision easier—not introduce ten more.</h2>
          <p>
            We created CMJ to give businesses a more grounded way to build. That
            means asking sharper questions, making complexity understandable,
            and staying accountable for the whole experience instead of handing
            work across disconnected teams.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="dark-section principles-section">
      <div className="site-container">
        <Reveal className="section-heading-row section-heading-dark">
          <div><p className="section-kicker">What guides us</p><h2>Principles over process theater.</h2></div>
          <p>Our work is structured enough to stay dependable and flexible enough to stay honest.</p>
        </Reveal>
        <div className="principle-grid">
          {principles.map((principle, index) => (
            <Reveal key={principle.number} delay={index * 90}>
              <article className="principle-card">
                <span>{principle.number}</span>
                <h3>{principle.title}</h3>
                <p>{principle.copy}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="light-section collaboration-section">
      <div className="site-container collaboration-grid">
        <Reveal className="collaboration-visual" direction="left">
          <MotionMedia
            className="collaboration-media"
            src="/images/shared-momentum.jpg"
            alt="Three distinct materials connected around a shared point of light"
            speed={38}
          />
          <div className="orbit orbit-one" />
          <div className="orbit orbit-two" />
          <div className="orbit-center"><Icon name="spark" /></div>
          <span className="orbit-label orbit-label-one">Your team</span>
          <span className="orbit-label orbit-label-two">Your customers</span>
          <span className="orbit-label orbit-label-three">CMJ</span>
        </Reveal>
        <Reveal delay={100} className="collaboration-copy">
          <p className="section-kicker">How we collaborate</p>
          <h2>Close enough to care. Experienced enough to challenge.</h2>
          <p>
            You work directly with the people shaping and building the product.
            We bring curiosity, candid advice, and a bias toward the simplest
            solution that can create real value.
          </p>
          <div className="inline-facts">
            <span><strong>Direct</strong> communication</span>
            <span><strong>Shared</strong> decisions</span>
            <span><strong>Long-term</strong> thinking</span>
          </div>
        </Reveal>
      </div>
    </section>

    <ProofSection />

    <ContactSection />
  </SiteLayout>
);

export default AboutComponent;
